<template>
    <App title="Code Validation">
        <template #top>
            <Alert ref="alert" class="alert-danger">
                {{ message }}
            </Alert>
        </template>
        <div class="w-100">
            <Block type="form" class="w-75 mx-auto">
                <template #header>
                    <h3 class="block-title">Validate Code & Engine Number</h3>
                </template>
                <div class="row">
                    <div class="col-12">
                        <div class="input-group mb-3">
                            <input id="code" v-model="code" label="Code" placeholder="Order Code" class="form-control form-control-lg" :disabled="loading" />
                            <button class="btn btn-outline-secondary" type="button" @click="onCheck">Check</button>
                        </div>
                    </div>
                </div>

                <div v-if="checkComplete" class="row">
                <div class="col-12">
                    <div class="row g-3">
                        <TextBlock label="Order Amount">
                            {{ checkComplete.id }}
                        </TextBlock>
                    </div>
                    <div class="row g-3">
                        <TextBlock label="Order Created">
                            {{ checkComplete.created_at }}
                        </TextBlock>
                    </div>
                    <div class="row mt-3">
                        <div class="col text-center">
                            <button id="action" :disabled="loading || done || order.claims_left == 0 " class="btn btn-primary" @click="onSubmit">{{ label }}</button>
                        </div>
                    </div>
                </div>
            </div>
                
            </Block>
        </div>
    </App>
</template>
<script lang="ts">
import Alert from '@/vue/components/Alert.vue'
import Block from '@/vue/components/Block.vue'
import App from '@/vue/templates/App.vue'
import { AxiosError } from 'axios'
import { Component, Vue, toNative } from 'vue-facing-decorator'

@Component({
    components: {
        App,
        Block,
        Alert
    }
})
class Single extends Vue {

    message = ''

    loading = false

    done = false

    code = ''

    checkComplete = null as any
    

    

    get label() {
        return this.done ? 'Checked' : 'Check'
    }

    onCheck() {
        this.loading = true
        this.$http
            .get(this.route('code.ajax.check', { identifier: this.code }))
            .then(({ data }) => {
                this.checkComplete = data.data
                this.done = false
            })
            .catch((e: AxiosError) => this.$error(e, this, true))
            .finally(() => this.loading = false)
    }

    onSubmit() {
        this.loading = true
        this.$http
            .post(this.route('code.ajax.validate'), { code: this.code?.id })
            .then(({ data }) => {
                this.done = true
                this.checkComplete = data.data
            })
            .catch((e: AxiosError) => this.$error(e, this, true))
            .finally(() => this.loading = false)
    }
}

export default toNative(Single)
</script>
